import {IconButton, Typography} from '@mui/material';
import {ReactNode} from 'react';
import {useNavigate} from 'react-router-dom';
import ArrowBackIcon from '@icons/ArrowBackIcon';
import ArrowHomeIcon from '@icons/ArrowHomeIcon';


interface IProps {
	title: string | ReactNode;
	backUrl?: string;
	home?: boolean;
	back?: boolean;
}

export default function HeaderWithIcons({title, backUrl, home = false, back = true}: IProps) {
	const navigate = useNavigate();
	const handleBackClicked = () => {
		if (backUrl) {
			navigate(backUrl);
		} else {
			navigate(-1);
		}
	};
	const handleHomeClicked = () => {
		navigate('/');
	};
	
	return (
		// <div className="sticky">
		<div className="flex flex-row space-x-3 rtl:space-x-reverse mx-4 h-14 items-center">
			{
				back && <IconButton onClick={handleBackClicked}>
					<ArrowBackIcon/>
				</IconButton>
			}
			<Typography sx={{fontSize: (theme) => theme.typography.fontSize + 6}}
			            className="font-medium">{title}</Typography>
			{
				home && <div className="flex-1 flex w-full self-center justify-end">
					<IconButton onClick={handleHomeClicked} className="w-10 h-10">
						<ArrowHomeIcon/>
					</IconButton>
				</div>
			}
		</div>
		// </div>
	);
}
